import { useRecoilState } from "recoil";
import { languageAtom } from "../store";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

const useLanguage = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useRecoilState(languageAtom);

  useEffect(() => {
    localStorage.setItem("language", language);
    //   config.headers["Accept-Language"] =
    axios.defaults.headers["Accept-Language"] = language;
    localStorage.getItem("language") || "zh";
    i18n.changeLanguage(language);

    document.body.setAttribute("data-language", language);
  }, [language]);
  return { language, setLanguage };
};

export default useLanguage;
